import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 85%, rgb(240,253,244) 100%)'
  }} data-id="element-204">
      <div className="mx-auto max-w-2xl" data-id="element-205">
        <div className="rounded-2xl overflow-hidden shadow-sm text-center" style={{
        border: '1px solid rgba(34,197,94,0.3)'
      }} data-id="element-206">
          {/* Header */}
          <div className="px-6 py-5" style={{
          background: 'linear-gradient(135deg, rgb(21,128,61), rgb(22,163,74))'
        }} data-id="element-207">
            <div className="text-4xl mb-2" data-id="element-208">🛡️</div>
            <h2 className="text-lg font-black text-white m-0" data-id="element-209">
              Garantía de 7 días — Sin preguntas
            </h2>
          </div>

          {/* Body */}
          <div className="px-6 py-6" style={{
          backgroundColor: 'rgb(240,253,244)'
        }} data-id="element-210">
            <p className="text-2xl font-black text-green-700 m-0 mb-2" data-id="element-211">
              Te devolvemos el 100%.
            </p>
            <p className="text-sm text-gray-600 m-0" data-id="element-212">
              Si en 7 días no es lo que esperabas, escribinos y listo.
              <br data-id="element-213" />
              Sin formularios. Sin drama.
            </p>
          </div>
        </div>
      </div>
    </section>;
}